import axios from 'axios'
import qs from 'qs'
import { Loading } from 'element-ui';
import CryptoJS from "crypto-js"
import Vue from 'vue'
import router from '../router'

// POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
    return config;
},(error) =>{
    console.log('錯誤的參數',error)
    return Promise.reject(error);
});

// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) =>{
    // 对响应数据做些事
    if(!res.data.success){
        return Promise.resolve(res);
    }
    return res;
}, (error) => {
    console.log('網絡異常',error)
    return Promise.reject(error);
});

export function file(url, params, isload=true){
    if(isload){
        var load = Loading.service({
            lock: true,
            text: '......',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        })
    }
    let token = Vue.prototype.common.token()
    let headers = token?{headers: {'token': token }}:{}
    return new Promise((resolve, reject) => {
        axios.post(url, params, headers)
        .then(response => {
            if(isload){ load.close() }
            resolve(response);
        }, err => {
            if(isload){ load.close() }
            reject(err);
        })
        .catch((error) => {
            if(isload){ load.close() }
            reject(error)
        })
    })
}

// 返回一个Promise(发送post请求)
export function post(url, params, isload=true) {
    if(isload){
        var load = Loading.service({
            lock: true,
            text: '......',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        })
    }
    params = qs.stringify(params)
    let token = Vue.prototype.common.token()
    let lang = Vue.prototype.global.lang?Vue.prototype.global.lang:"TC"
    let headers = token?{headers: {'token': token,'lang': lang }}:{}
    return new Promise((resolve, reject) => {
        axios.post(url, params, headers)
        .then(response => {
            if(isload){ load.close() }
            resolve(response);
        }, err => {
            if(isload){ load.close() }
            reject(err);
        })
        .catch((error) => {
            if(isload){ load.close() }
            reject(error)
        })
    })
}
// 返回一个Promise(发送get请求)
export function get(url, param) {
    return new Promise((resolve, reject) => {
        axios.get(url, {params: param})
        .then(response => {
            resolve(response)
        }, err => {
            reject(err)
        })
        .catch((error) => {
            reject(error)
        })
    })
}
// 返回一个TOKEN
export function token(callback){
    let params = Vue.prototype.global.authentication
    params.token = Vue.prototype.common.token()
    Vue.prototype.curl.post("/app/token/renew",params,false).then((e) => {
        if(parseInt(e.data.code)!=0){
            sessionStorage.removeItem('voucher')
            localStorage.removeItem('voucher')
            localStorage.removeItem('token')
            router.push({ path: '/transfer' })
        }else{
            let token = CryptoJS.AES.encrypt(e.data.data.token,Vue.prototype.global.secret_key).toString();
            localStorage.setItem('token', token)
            if(typeof callback == "function") callback()
        }
    }).catch(err=>{
        sessionStorage.removeItem('voucher')
        localStorage.removeItem('voucher')
        localStorage.removeItem('token')
        router.push({ path: '/transfer' })
    }) 
}
export function create(callback){
    let params = Vue.prototype.global.authentication
    let token = Vue.prototype.common.token()
    Vue.prototype.curl.post("/app/token/create",params,false).then((e) => {
        if(e.data.code==0){
            let token = CryptoJS.AES.encrypt(e.data.data,Vue.prototype.global.secret_key).toString();
            localStorage.setItem('token',token); 
            if(typeof callback == "function") callback()
        }else{
            Vue.prototype.$notify({ type: 'warning', message: "系統繁忙", duration: Vue.prototype.global.msg_duration })
        }
    }).catch(err=>{
        console.log(err)
    })
}
export default { post,get,token,file,create }


// WEBPACK FOOTER //
// ./src/utils/curl.js